(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('bs-back-to-top');
    if (!btn) return;
    window.addEventListener('scroll', () => {
      btn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  });

  /* ===== INJECTION DES ÉTOILES DANS LES CARTES ===== */
  function renderStars(rating, count) {
    const full  = Math.floor(rating);
    const half  = (rating - full) >= 0.5;
    const empty = 5 - full - (half ? 1 : 0);
    let stars = '';
    for (let i = 0; i < full;  i++) stars += '<span class="bs-star">★</span>';
    if (half)                        stars += '<span class="bs-star bs-star--half">★</span>';
    for (let i = 0; i < empty; i++) stars += '<span class="bs-star bs-star--empty">★</span>';
    return '<div class="bs-product-rating" aria-label="' + rating + ' étoiles — ' + count + ' avis"><span class="bs-product-rating__stars" aria-hidden="true">' + stars + '</span><span class="bs-product-rating__count">(' + count + ')</span></div>';
  }

  function injectRatings() {
    document.querySelectorAll('.product-grid__item[data-product-id]').forEach(item => {
      if (item.querySelector('.bs-product-rating')) return;
      const rating = parseFloat(item.dataset.rating || '0');
      const count  = parseInt(item.dataset.ratingCount || '0', 10);
      if (!count) return;
      const titleEl = item.querySelector('.product-card__title, .product-title, [class*="title"], h3, h2');
      if (!titleEl) return;
      titleEl.insertAdjacentHTML('afterend', renderStars(rating, count));
    });
  }

  document.addEventListener('DOMContentLoaded', injectRatings);
  document.addEventListener('results-list:updated', injectRatings);

  /* ===== MASQUER COMPTEUR NATIF SUR NOUVEAUTÉS ===== */
  (function() {
    const handle = document.body.dataset.collectionHandle
      || window.location.pathname.split('/collections/')[1]?.split('/')[0];

    if (handle === 'nouveaute' || handle === 'nouveautes' || handle === 'best-sellers') {
      const selectors = [
        '.collection-products-count',
        '.facets__product-count',
        '[data-products-count]',
        '.product-count',
        '.collection-count',
      ];
      function hideNativeCount() {
        selectors.forEach(sel => {
          document.querySelectorAll(sel).forEach(el => {
            const num = parseInt(el.textContent.replace(/\D/g, ''), 10);
            if (!isNaN(num) && num > 50) el.style.display = 'none';
          });
        });

        // Masquer la pagination
        const paginationSelectors = [
          '.pagination', '[data-pagination]',
          'nav[aria-label*="agination"]',
          '.pagination-wrapper', 'load-more-button', '.load-more'
        ];
        paginationSelectors.forEach(sel => {
          document.querySelectorAll(sel).forEach(el => el.style.display = 'none');
        });
      }
      hideNativeCount();
      // Au cas où le thème met à jour le DOM après
      const obs = new MutationObserver(hideNativeCount);
      obs.observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
